import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTodos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTodos"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H15V20H9V21H3V3ZM16.1427 9.00423L14.5042 7.85731L11.0698 12.7636L9.15593 11.0889L7.83892 12.5941L11.4302 15.7364L16.1427 9.00423Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTodos;
